export const getUser = state => state.user.user;
export const getAllowedShiftRoles = state => state.user.allowedShiftRoles;
export const getUsers = state => state.user.users;
export const getUserRoles = state => state.user.user.userRoles;
